/**
 * Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com).
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import VendorConstants from '../constants/VendorConstants';

/**
 * Adds a vendor-specific prefix to a CSS class name.
 *
 * @param className - The original CSS class name to be prefixed
 * @returns A new string with the vendor prefix added to the class name
 *
 * @example
 * ```typescript
 * // Usage with clsx
 * clsx(withVendorCSSClassPrefix('sign-in-button'), className)
 * // Result: "wso2-sign-in-button"
 * ```
 */
const withVendorCSSClassPrefix = (className: string): string => `${VendorConstants.VENDOR_PREFIX}-${className}`;

export default withVendorCSSClassPrefix;
